import React, { useState } from 'react';

import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';
import DataRules from '../components/RulesSection/RulesComponent/DataRules';
import { articleObjThree } from '../components/RulesSection/RulesComponent/Data';



const PolitykaPrywatnosci = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

  return (
    <>
        <Sidebar isOpen={isOpen} toggle={toggle} />
        <Navbar toggle={toggle}/> 
        <DataRules {...articleObjThree}/>
        <Footer />
    </>
  );
};

export default PolitykaPrywatnosci;